<template>
    <v-dialog activator="parent" scrollable>
        <template v-slot:default="{ isActive }">
            <v-card>
                <v-card-title><b>Stammdaten</b> - {{ header }}</v-card-title>
                <v-card-text>
                    <div class="d-flex flex-column">
                        <div class="d-flex flex-column border border-primary border-opacity-100">
                            <div class="d-flex flex-nowrap">
                                <input-header title="Titel" />
                                <text-field
                                    v-model="editUser.titel"
                                    :is-loading="isLoading"
                                    autocomplete="off"
                                    placeholder="Titel"
                                    class="border border-primary border-opacity-100"
                                />
                            </div>
                            <div class="d-flex flex-nowrap">
                                <input-header title="Vorname" />
                                <text-field
                                    v-model="editUser.vorname"
                                    :is-loading="isLoading"
                                    autocomplete="off"
                                    placeholder="Vorname"
                                    class="border border-primary border-opacity-100"
                                />
                            </div>
                            <div class="d-flex flex-nowrap">
                                <input-header title="Nachname" />
                                <text-field
                                    v-model="editUser.nachname"
                                    :is-loading="isLoading"
                                    class="border border-primary border-opacity-100"
                                    autocomplete="off"
                                    placeholder="Nachname"
                                />
                            </div>

                            <div class="d-flex flex-nowrap">
                                <input-header title="E-Mail" />
                                <text-field
                                    v-model="editUser.email"
                                    :is-loading="isLoading"
                                    type="email"
                                    autocomplete="off"
                                    placeholder="E-Mail"
                                    class="border border-primary border-opacity-100"
                                />
                            </div>
                        </div>
                    </div>
                </v-card-text>
                <v-card-actions class="mr-4">
                    <v-btn
                        type="reset"
                        color="primary"
                        variant="outlined"
                        :disabled="isLoading"
                        @click="resetEditUser()"
                    >
                        Reset
                    </v-btn>
                    <v-btn
                        variant="tonal"
                        :loading="isLoading"
                        color="primary"
                        @click="handleSaveUser(isActive)"
                        >Speichern
                    </v-btn>
                </v-card-actions>
                <v-divider></v-divider>
                <v-card-title><b>Rollen</b> - {{ header }}</v-card-title>
                <v-card-text>
                    <user-rollen v-if="userId" :user-id="userId" />
                </v-card-text>
            </v-card>
        </template>
    </v-dialog>
</template>

<script setup>
    import { useAlertStore, useUserStore } from '@/js/stores'
    import { computed, onMounted, ref, watch } from 'vue'
    import InputHeader from '@/js/components/Common/InputHeader.vue'
    import UserRollen from '@/js/components/Benutzer/UserRollen.vue'
    import { TextField } from '@/js/components/Common'

    const props = defineProps({
        userId: {
            type: String,
            required: true
        }
    })

    const alertStore = useAlertStore()
    const userStore = useUserStore()
    const editUser = ref({})
    const header = ref('')

    const isLoading = computed(() => userStore.isLoading)

    const resetEditUser = function () {
        if (!props.userId) {
            return
        }

        const user = userStore.getUserById(props.userId)
        editUser.value['titel'] = user.titel
        editUser.value['vorname'] = user.vorname
        editUser.value['nachname'] = user.nachname
        editUser.value['email'] = user.email.email
        header.value = `${editUser?.value.titel} ${editUser?.value.vorname} ${editUser?.value.nachname}`
    }

    onMounted(() => {
        resetEditUser()
    })

    watch(
        () => props.userId,
        () => {
            resetEditUser()
        }
    )

    const handleSaveUser = async (isActive) => {
        await userStore.saveUser(props.userId, { ...editUser.value })
        if (!userStore.hasErrors) {
            alertStore.success('Nutzer erfolgreich gespeichert.', 'Info')
            isActive.value = false
        } else {
            alertStore.error('Fehler beim Speichern des Nutzers.', 'Fehler!')
        }
    }
</script>

<style lang="scss"></style>
